module.exports = __webpack_public_path__ + "img/keg_query.png";